import * as React from "react";
import EditorialBase from "../../EditorialBase";
import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import IconSectionEditorial from "./IconSectionEditorial";
import CardComparisonSection from "./CardComparisonSection";
import CitiTripleDipSectionEditorial from "./Citi/CititripledipSectionEditorial";
import CitiDesktopStickyBar from "./Citi/CitiDesktopStickybar";
import CitifaqSectionEditorial from "./Citi/CitiFaqSectionEditorial";
import CitiRewardsWithoutCompSectionEditorial from "./Citi/CitiRewardsWithoutCompSectionEditorial";
import CitiCalculatorSectionEditorial from "./Citi/CitiCalculatorSectionEditorial";
import HeroImageEditorial from "./Citi/HeroImageEditorial";
import CitiCardModalDialog from "components/flexComponents/Content/factory/impl/editorials/Citi/CitiCardModalDialog";
import CitiContent from "./Citi/CitiContent";

export class Grid3 extends EditorialBase {
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const { model } = props.flexComponent;
    const stickyBarText = "Sticky_bar";
    const RwcSection = "Citi_Rwc_Section";
    const iconSectionTitle = "icon_section";
    const cardComparisonSection = "Citi_Card_comparision";
    const calculatorSectionTitle = "Citi_Calculator_Section";
    const heroImage = "hero_image";
    const cardModalDialog = "Card_modal_dialog";
    const citiContent = "Citi_Content";

    return (
      <>
        {model.title.includes("triple_dip_section") && (
          <CitiTripleDipSectionEditorial
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
          />
        )}

        {model.title.includes(stickyBarText) && (
          <CitiDesktopStickyBar flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}

        {model.title.includes("Citi_Faq_Section") && (
          <CitifaqSectionEditorial flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}

        {model.title.includes(RwcSection) && (
          <CitiRewardsWithoutCompSectionEditorial
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
          />
        )}

        {model.title.includes(iconSectionTitle) && (
          <IconSectionEditorial flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}

        {model.title.includes(cardComparisonSection) && (
          <CardComparisonSection flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}

        {model.title.includes(calculatorSectionTitle) && (
          <CitiCalculatorSectionEditorial
            flexComponent={props.flexComponent}
            l10n={props.l10n}
            context={props.context}
          />
        )}

        {model.title.includes(heroImage) && (
          <HeroImageEditorial flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}

        {model.title.includes(cardModalDialog) && (
          <CitiCardModalDialog
            flexComponent={props.flexComponent}
            context={props.context}
            routeStore={props.routeStore}
          />
        )}

        {model.title.includes(citiContent) && (
          <CitiContent flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
        )}
      </>
    );
  }
}

export default Grid3;
